<div fxLayout="column" fxFlexFill>
  <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>
  <div fxFlex="auto" fxFlexFill class="table-container">
    <mat-table [dataSource]="dataSource" multiTemplateDataRows class="regular-table responsive padding-left-10"
               matSort matSortActive="number" matSortDirection="desc" matSortDisableClear>
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Select for edit:</span>
          <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                        (change)="$event ? selectedRows.toggle(row) : null"
                        [checked]="selectedRows.isSelected(row)">
          </mat-checkbox>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="number">
        <mat-header-cell *matHeaderCellDef mat-sort-header="number">Phone Number</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Phone Number:</span>
          <a *ngIf="hasEditAccess" [routerLink]="[detailsUrl, row.id, 'edit']">{{row.number | phoneNumber}}</a>
          <span *ngIf="!hasEditAccess">{{row.number | phoneNumber}}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="customerDidAlias">
        <mat-header-cell *matHeaderCellDef mat-sort-header="customerDidAlias">Alias</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Alias:</span>
          <span>{{row.customerDidAlias}}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="phoneNumberStatusName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="phoneNumberStatusName">Voice Status</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Voice Status:</span>
          <span>{{row.phoneNumberStatusName}}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="phoneNumberType">
        <mat-header-cell *matHeaderCellDef mat-sort-header="phoneNumberType">Type</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Type:</span>
          <span>{{row.productTypeName}}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="campaignNumber">
        <mat-header-cell *matHeaderCellDef mat-sort-header="campaignNumber">Campaign #</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Campaign #</span>
          <span>{{row.campaignNumber}}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="cnam">
        <mat-header-cell *matHeaderCellDef mat-sort-header="cnam">
          Caller ID
          <app-explanation>
            Enter your preferred Company Caller ID Name exactly the way you want it to appear on Caller ID displays,
            for local calls made from your local TeleGo phone numbers. Caller ID should be active within 7 to 14
            business days.
            If the accurate Caller ID isn't showing 14 days after the request was submitted, contact support&#64;telego.net
            for assistance.
          </app-explanation>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Caller ID:</span>
          <span>
            <button mat-icon-button class="button-40" *ngIf="row.allowEditCnam && hasEditAccess"
                    (click)="onCnamEdit(row)"
                    matTooltip="Edit Caller ID">
              <mat-icon>edit</mat-icon>
            </button>
            <span *ngIf="row.allowEditCnam">
              {{row.cnam}}
            </span>
            <app-explanation *ngIf="!row.allowEditCnam">
              This feature isn't available for this number
            </app-explanation>
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="allUsers">
        <mat-header-cell *matHeaderCellDef mat-sort-header="allUsers">Assigned To</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Assigned To:</span>
          <app-explanation *ngIf="!row.allowSMS && !row.allowFax && !row.allowWaba">This feature isn't available for
            this number
          </app-explanation>
          <span *ngIf="row.allowSMS || row.allowWaba">
                  {{ row.allUsers && row.allUsers.length > 0 ? 'Assigned' : 'Not Assigned' }}
            <app-explanation *ngIf="row.allUsers && row.allUsers.length > 0">
              <label>Messaging Assigned To:</label><br/>
              <span *ngFor="let item of row.allUsers">
                {{item.firstname}} {{item.lastname}}<br>
              </span>
            </app-explanation>
          </span>
          <span *ngIf="row.allowFax">
                  {{ row.allUsers && row.allUsers.length > 0 ? 'Assigned' : 'Not Assigned' }}
            <app-explanation *ngIf="row.allUsers && row.allUsers.length > 0">
              <label>Fax Assigned To:</label><br/>
              <span *ngFor="let item of row.allUsers">
                {{item.firstname}} {{item.lastname}}<br>
              </span>
            </app-explanation>
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="feature">
        <mat-header-cell *matHeaderCellDef mat-sort-header="feature">Additional Features</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Additional Features:</span>
          <span *ngIf="row.allowSMS">
            {{ row.feature }}
            : <span
            style="font-weight: bold">{{ row.smsEnabled ? 'On' : 'Off' }}</span>
            <app-explanation *ngIf="row.smsEnabled"
                             [style.color]="row.smsStatus === 'Active' ? '#39CB76' : row.smsStatus === 'Processing' ? '#ff684a' : '#ff4b32'"
              icon="{{row.smsStatus === 'Active' ? 'check_circle' : row.smsStatus === 'Processing' ? 'report_problem' : 'error_outline'}}"
            >
              SMS Service - {{row.smsStatus ? row.smsStatus : 'Unknown'}}
            </app-explanation>
          </span>
          <span *ngIf="row.allowFax">
            Fax Over Portal: <span style="font-weight: bold">On</span>
          </span>
          <span *ngIf="row.allowWaba && !row.allowSMS">
            Business WhatsApp: <span style="font-weight: bold">On</span>
          </span>
        </mat-cell>
      </ng-container>

      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
    </mat-table>
  </div>
  <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
</div>
